import type { NumberFormatterOptions } from "../../../../../../../../api/types/fieldConfigurationTypes.ts";
import { CalculationType } from "../../../../../../../../api/types/fieldConfigurationTypes.ts";
import { pluralize } from "@entrilia/shared/utilities/stringHelper.ts";
import type { CustomColumnField } from "../../../../../../../../api/types/svTypes.ts";
import { newCustomColumnField } from "../../../../utilities/fieldsHelper.ts";
import type { CustomColumnData } from "../../common/fields/custom-field/customColumn.types.ts";

export interface StatementFormula {
  customLabel?: string;
  formula?: string;
  formulaParameters: string[];
  format?: NumberFormatterOptions;
  blankIfMissingValue: boolean;
}

export const toFormulaDialogField = (source: StatementFormula): CustomColumnField =>
  newCustomColumnField({
    name: source.customLabel ?? "",
    selectedFormulaParameterIds: source.formulaParameters,
    selectedCalculationType: CalculationType.CustomFormula,
    formula: source.formula ?? "",
    format: source.format,
    blankIfMissingValue: source.blankIfMissingValue,
  });

export type FormulaReferrer = "formula" | "formula column";

export const getRemoveBlockedMessage = <T extends Pick<StatementFormula, "formulaParameters">>(
  items: T[],
  guid: string,
  getLabel: (item: T) => string,
  referrer: FormulaReferrer = "formula"
): string | undefined => {
  const formulas = items.filter((item) => item.formulaParameters.includes(guid));
  const [formula] = formulas;
  if (!formula) {
    return undefined;
  }
  return formulas.length === 1
    ? `Used by the ${referrer} “${getLabel(formula)}” — edit it first.`
    : `Used by ${formulas.length} ${pluralize(referrer, formulas.length)} — edit them first.`;
};

export const toStatementFormula = (data: CustomColumnData): StatementFormula => ({
  customLabel: data.name,
  formula: data.formula,
  formulaParameters: data.selectedFormulaParameterIds,
  format: data.format,
  blankIfMissingValue: data.blankIfMissingValue === true,
});
